import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import './index.css'

const rootElement = document.getElementById('root')
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)

// If root has pre-rendered HTML (not just ssr-outlet comment), hydrate; otherwise create fresh root
const hasPrerenderedContent = rootElement.innerHTML.trim().length > 0 && !rootElement.innerHTML.trim().startsWith('<!--')
if (hasPrerenderedContent) {
  ReactDOM.hydrateRoot(rootElement, app)
} else {
  ReactDOM.createRoot(rootElement).render(app)
}
